<div class="reward-token-card__top-combined">
    <ng-container *ngIf="!isRewardDrawerEnabled; then RewardToken; else newRewardTokencss" />

    <ng-template #RewardToken>
        <div class="reward-token-card__header-combined">
            <div class="reward-token-card__title reward-token-card__title-combined">{{ tokenTitle }}</div>
            <div class="risk-free-card__max-return">{{ maxReturnDetails }}</div>
        </div>
    </ng-template>
    <ng-template #newRewardTokencss>
        <div class="reward-token-card__header-combined">
            @if (vipBadgeTemplate) {
                <ng-container [ngTemplateOutlet]="vipBadgeTemplate" />
            }
            <div class="reward-drawer__title reward-risk-free-drawer__title reward-token-card__title reward-token-card__title-combined">
                <span class="reward-riskfree-title">{{ tokenTitle }}</span>
                <span class="reward-riskfree-title-returns" *ngIf="!isRewardDrawerEnabled">{{ ' (' + maxReturnDetails + ')' }}</span>
            </div>
        </div>
    </ng-template>

    <div class="reward-token-card-category-link">
        <bs-reward-token-categories
            [categories]="tokenCategories"
            [tokenFilter]="token.filter"
            [isRewardDrawerEnabled]="isRewardDrawerEnabled"
            [betType]="betType.length > 0 ? betType[0].value : ''" />
        <bs-reward-token-card-info-link
            *ngIf="termsAndConditionLinkText"
            [token]="token"
            [withArrow]="false"
            [overrideLinkTitleHtml]="termsAndConditionLinkText" />
    </div>
</div>

<div class="risk-free-card__link-group" *ngIf="tokenLimitations.length > 0">
    <bs-reward-token-limitations [limitations]="tokenLimitations" [isRewardDrawerEnabled]="isRewardDrawerEnabled" />
</div>

<div class="reward-token-card__payout-details" *ngIf="showPayout">
    <span class="reward-token-card__payout-title"> {{ tokenPayoutTitle }}&nbsp; </span>
    <span>{{ payoutDetails }}&nbsp;</span>
    <span class="reward-token-card__token-payout-description" *ngIf="isRewardDrawerEnabled">{{ sitecore.crmTokens.riskFree.card.Payout }} </span>
</div>
<div [class.reward-token-footer-details]="applyRemoveButtonsShowHide()">
    <bs-reward-token-footer-details
        [expireTokenReward]="expireTokenReward"
        [token]="token"
        [promoHubUrlTokenType]="promoHubUrlTokenType"
        [isRewardBannerView]="isRewardBannerView"
        [tokenTitle]="tokenTitle"
        [tokenCategories]="tokenCategories" />
    @if (applyRemoveButtonsShowHide()) {
        <button ds-button size="small" variant="outline" kind="secondary">
            {{ applyOrRemoveTokenText }}
        </button>
    }
</div>
